// extracted by mini-css-extract-plugin
module.exports = {"modal-box":"iG","modalBox":"iG","modal-mask":"iH","modalMask":"iH","close-btn":"iI","closeBtn":"iI","container":"iJ","content":"iK","title":"iL","subTitle":"iM","detail":"iN"};